import compareRoles from '../compareRoles';

import { IActTeamMemberAvailableList } from '~/services/api/actTeamMember/types';
import { IUserRole } from '~/types';

const excludeGlobalUsers = (items: IActTeamMemberAvailableList[]): IActTeamMemberAvailableList[] =>
  (items || []).filter(
    item => !(item.roles?.length === 1 && compareRoles(IUserRole.GlobalUser, item.roles[0].name)),
  );

export default excludeGlobalUsers;
